module.exports = __webpack_public_path__ + "static/media/title.7a55947d.svg";